<template>
  <div class="wrapper">
    <div class="header">
      <span :class="(activeType == 0)?'nav active':'nav'"
            @click="switchContent(0)">文档</span>
      <span :class="(activeType == 1)?'nav active':'nav'"
            @click="switchContent(1)">调试</span>
    </div>
    <div class="content">
      <document-desc v-show="activeType == 0"></document-desc>
      <document-debug v-show="activeType == 1"></document-debug>
    </div>
  </div>
</template>
<script>
import DocumentDesc from '@/views/pc/document/api/desc/Index'
import DocumentDebug from '@/views/pc/document/api/debug/Index'
export default {
  name: 'DocumentApi',
  components: {
    DocumentDesc,
    DocumentDebug
  },
  data: function () {
    return {
      activeType: 0,
      hash: undefined
    }
  },
  watch: {
    $route(to, from) {
      this.hash = to.params.hash
    }
  },
  created() {
    this.hash = this.$route.params.hash
  },
  methods: {
    switchContent: function (activeType) {
      this.activeType = activeType
    }
  }
}
</script>
<style scoped>
.header {
  display: flex;
  flex-wrap: wrap;
}
.header .nav {
  color: #ff761a;
  cursor: pointer;
  padding: 10px 36px;
  font-size: 16px;
}
.header .nav.active {
  border-bottom: 2px solid #ff761a;
  font-weight: bold;
}
.content {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/document/api/index.vue